import { useCallback, useEffect, useState, useRef } from 'react';

// copied from https://github.com/dance2die/react-use-localstorage
export default function useLocalStorage(
  key: string,
  initialValue: string = ''
): [string | null, (v: string) => void] {
  const [value, setValue] = useState<string | null>(null);

  const setItem = useCallback(
    (newValue: string) => {
      setValue(newValue);
      window.localStorage.setItem(key, newValue);
    },
    [key, setValue]
  );

  useEffect(() => {
    const newValue = window.localStorage.getItem(key);
    if (value === null || value !== newValue) {
      setValue(newValue || initialValue);
    }
  }, [setValue, initialValue, key, value]);

  const handleStorage = useCallback(
    (event: StorageEvent) => {
      if (event.key === key && event.newValue !== value) {
        setValue(event.newValue || initialValue);
      }
    },
    [initialValue, key, value]
  );

  useEffect(() => {
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, [handleStorage]);

  return [value, setItem];
}
